<div class="flex h-full w-full flex-col justify-center rounded-3xl">
  <div class="typo-h6-light-uppercase mt-5 text-center text-text-tertiary">
    {{ (tooth().jaw === 'upper' ? 'perio_common_label_facial' : 'perio_common_label_lingual') | translate }}
  </div>
  <lib-teeth
    [currentTeeth]="displayedTeeth()"
    [isSingleToothView]="true"
    [isAnimated]="false"
    [singleTooth]="tooth()"
    [drawCross]="false"
    [drawLabels]="false"
    [singleToothViewContentWidth]="viewWidth"
    [singleToothViewContentHeight]="tooth().jaw === 'upper' ? upperJawViewHeight : lowerJawViewHeight"
    [isPerioExamView]="true"
    [activeSide]="activeSide()"
  ></lib-teeth>
  <div class="typo-h6-light-uppercase mt-6 text-center text-text-tertiary">
    {{ (tooth().jaw === 'upper' ? 'perio_common_label_lingual' : 'perio_common_label_facial') | translate }}
  </div>
</div>
